'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _require = require('p-queue'),
    Queue = _require.default;
/**
 * @typedef {import('peer-id')} PeerId
 */


var WorkerQueue = /*#__PURE__*/function () {
  /**
   * Creates a new WorkerQueue.
   *
   * @param {import('../index')} dht
   * @param {import('./run')} run
   * @param {import('./path')} path
   * @param {Function & {error: Function}} log
   */
  function WorkerQueue(dht, run, path, log) {
    _classCallCheck(this, WorkerQueue);

    this.dht = dht;
    this.run = run;
    this.path = path;
    this.log = log;
    this.concurrency = this.dht.concurrency;
    this.queue = this.setupQueue(); // a container for resolve/reject functions that will be populated
    // when execute() is called

    /** @type {{ resolve: (result?: any) => void, reject: (err: Error) => void} | null} */

    this.execution = null;
    /** @type {Set<PeerId>} */

    this.queuedPeerIds = new Set();
  }
  /**
   * Create the underlying async queue.
   *
   * @returns {Queue}
   */


  _createClass(WorkerQueue, [{
    key: "setupQueue",
    value: function setupQueue() {
      var _this = this;

      var q = new Queue({
        concurrency: this.concurrency
      }); // When all peers in the queue have been processed, stop the worker

      q.on('idle', function () {
        if (_this.path.peersToQuery && !_this.path.peersToQuery.length) {
          _this.log('queue:drain');

          _this.stop();
        }
      }); // When a space opens up in the queue, add some more peers

      q.on('next', function () {
        if (!_this.running) {
          return;
        }

        if (q.pending < _this.concurrency) {
          _this.fill();
        }
      });
      return q;
    }
    /**
     * Stop the worker, optionally providing an error to pass to the worker's
     * callback.
     *
     * @param {Error} [err]
     */

  }, {
    key: "stop",
    value: function stop(err) {
      if (!this.running) {
        return;
      }

      this.running = false;
      this.queue.clear();
      this.log('worker:stop, %d workers still running', this.run.workers.filter(function (w) {
        return w.running;
      }).length);

      if (this.execution) {
        if (err) {
          this.execution.reject(err);
        } else {
          this.execution.resolve();
        }
      }
    }
    /**
     * Use the queue from async to keep `concurrency` amount items running
     * per path.
     *
     * @returns {Promise<void>}
     */

  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var execPromise;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.running = true; // store the promise resolution functions to be resolved at end of queue

                this.execution = null;
                execPromise = new Promise(function (resolve, reject) {
                  _this2.execution = {
                    resolve: resolve,
                    reject: reject
                  };
                }); // start queue

                this.fill(); // await completion

                _context.next = 6;
                return execPromise;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function execute() {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
    /**
     * Add peers to the worker queue until there are enough to satisfy the
     * worker queue concurrency.
     * Note that we don't want to take any more than those required to satisfy
     * concurrency from the peers-to-query queue, because we always want to
     * query the closest peers to the key first, and new peers are continuously
     * being added to the peers-to-query queue.
     */

  }, {
    key: "fill",
    value: function fill() {
      var _this3 = this;

      if (!this.path.peersToQuery) {
        return;
      } // Note:
      // - queue.pending: number of items that are currently running
      // - queue.size: the number of items that are waiting to be run


      var _loop = function _loop() {
        var peer = _this3.path.peersToQuery.dequeue(); // store the peer id so we can potentially abort early


        _this3.queuedPeerIds.add(peer);

        _this3.queue.add(function () {
          return _this3.processNext(peer).catch(function (err) {
            _this3.log.error('queue', err);

            _this3.stop(err);
          }).finally(function () {
            _this3.queuedPeerIds.delete(peer);
          });
        });
      };

      while (this.queue.pending + this.queue.size < this.concurrency && this.path.peersToQuery.length > 0) {
        _loop();
      }
    }
    /**
     * Process the next peer in the queue
     *
     * @param {PeerId} peer
     */

  }, {
    key: "processNext",
    value: function () {
      var _processNext = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peer) {
        var continueQuerying, continueQueryingError, state, execError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.running) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (!this.run.peersSeen.has(peer.toB58String())) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return this.run.continueQuerying(this);

              case 7:
                continueQuerying = _context2.sent;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);
                continueQueryingError = _context2.t0;

              case 13:
                if (this.running) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return");

              case 15:
                if (!continueQueryingError) {
                  _context2.next = 17;
                  break;
                }

                throw continueQueryingError;

              case 17:
                if (continueQuerying) {
                  _context2.next = 20;
                  break;
                }

                this.stop();
                return _context2.abrupt("return");

              case 20:
                if (!this.run.peersSeen.has(peer.toB58String())) {
                  _context2.next = 22;
                  break;
                }

                return _context2.abrupt("return");

              case 22:
                this.run.peersSeen.add(peer.toB58String()); // Execute the query on the next peer

                this.log('queue:work');
                _context2.prev = 24;
                _context2.next = 27;
                return this.execQuery(peer);

              case 27:
                state = _context2.sent;
                _context2.next = 33;
                break;

              case 30:
                _context2.prev = 30;
                _context2.t1 = _context2["catch"](24);
                execError = _context2.t1;

              case 33:
                if (this.running) {
                  _context2.next = 35;
                  break;
                }

                return _context2.abrupt("return");

              case 35:
                this.log('queue:work:done', execError, state);

                if (!execError) {
                  _context2.next = 38;
                  break;
                }

                throw execError;

              case 38:
                if (!(state && state.queryComplete)) {
                  _context2.next = 42;
                  break;
                }

                this.log('query:complete');
                this.run.stop();
                return _context2.abrupt("return");

              case 42:
                // If path is complete, just stop this worker.
                // Note: this.stop() kills the queue and resolves execution
                if (state && state.pathComplete) {
                  this.stop();
                }

              case 43:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10], [24, 30]]);
      }));

      function processNext(_x) {
        return _processNext.apply(this, arguments);
      }

      return processNext;
    }()
    /**
     * Execute a query on the next peer.
     *
     * @param {PeerId} peer
     */

  }, {
    key: "execQuery",
    value: function () {
      var _execQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peer) {
        var _this4 = this;

        var res, queryError, queryCloser;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.path.queryFunc(peer);

              case 3:
                res = _context4.sent;
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                queryError = _context4.t0;

              case 9:
                if (this.running) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return");

              case 11:
                if (!queryError) {
                  _context4.next = 14;
                  break;
                }

                this.run.errors.push(queryError);
                return _context4.abrupt("return");

              case 14:
                _context4.t1 = this.run.peersQueried;

                if (!_context4.t1) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 18;
                return this.run.peersQueried.add(peer);

              case 18:
                if (res) {
                  _context4.next = 20;
                  break;
                }

                return _context4.abrupt("return");

              case 20:
                if (!(res.pathComplete || res.queryComplete)) {
                  _context4.next = 23;
                  break;
                }

                this.path.res = res;
                return _context4.abrupt("return", {
                  pathComplete: res.pathComplete,
                  queryComplete: res.queryComplete
                });

              case 23:
                if (!(res.closerPeers && res.closerPeers.length > 0)) {
                  _context4.next = 27;
                  break;
                }

                /**
                 * @param {import('../').PeerData} closer
                 */
                queryCloser = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(closer) {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!_this4.dht._isSelf(closer.id)) {
                              _context3.next = 2;
                              break;
                            }

                            return _context3.abrupt("return");

                          case 2:
                            _this4.dht._peerDiscovered(closer.id, closer.multiaddrs);

                            _context3.next = 5;
                            return _this4.path.addPeerToQuery(closer.id);

                          case 5:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function queryCloser(_x3) {
                    return _ref.apply(this, arguments);
                  };
                }();

                _context4.next = 27;
                return Promise.all(res.closerPeers.map(queryCloser));

              case 27:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 6]]);
      }));

      function execQuery(_x2) {
        return _execQuery.apply(this, arguments);
      }

      return execQuery;
    }()
  }]);

  return WorkerQueue;
}();

module.exports = WorkerQueue;